import {action, observable} from 'mobx';
import trackStore from '../containers/main/track/store';
import projectStore from '../containers/main/project/store';
import {SearchState} from '../constants/enums';
import {BPM_MAX, BPM_MIN} from '../constants/constants';

class SearchStore {
    @observable searchStr = '';
    @observable isFiltered = false;
    @observable searchStateObjs = this.initSearchStateObjs();

    initSearchStateObjs() {
        return [
            {
                state: SearchState.myUploads,
                searchStr: null,
                fetch: trackStore.fetchOwnedTracks,
                reset: trackStore.setOwnedTracksCurrentPage,
                bpm: this.initBpm()
            },
            {state: SearchState.sampleBank, searchStr: null, fetch: trackStore.fetchTracks, reset: trackStore.setCurrentPage, bpm: this.initBpm()},
            {state: SearchState.studentLessons, searchStr: null, fetch: projectStore.getStudentLessons, reset: projectStore.resetPagination},
            {state: SearchState.lessonPlanLibrary, searchStr: null, fetch: projectStore.getLessonPlanLibrary, reset: projectStore.resetPagination, filters: {}},
            {state: SearchState.teacherLessons, searchStr: null, fetch: projectStore.getTeacherLessons, reset: projectStore.resetPagination},
            {state: SearchState.studentsProjects, searchStr: null, fetch: projectStore.getGroupedStudentProjects, reset: projectStore.resetPagination},
            {state: SearchState.studentActivities, searchStr: null, fetch: projectStore.fetchStudentActivities, reset: projectStore.resetPagination},
            {state: SearchState.drafts, searchStr: null, fetch: projectStore.getDrafts, reset: projectStore.resetPagination},
            {state: SearchState.lessonActivities, searchStr: null, fetch: projectStore.fetchLessonActivities, reset: projectStore.resetPagination},
            {state: SearchState.discovery, searchStr: null, fetch: projectStore.getLessonPlans, reset: projectStore.resetPagination, filters: {}},
            {state: SearchState.discoveryPublic, searchStr: null, fetch: projectStore.getPublicLessonPlans, reset: projectStore.resetPagination, filters: {}},
            {state: SearchState.introLessons, searchStr: null, fetch: projectStore.getLessonPlans, reset: projectStore.resetPagination, filters: {}},
            {state: SearchState.lessonsLibrary, searchStr: null, fetch: projectStore.getLibraryLessons, reset: projectStore.resetPagination, filters: {}},
        ];
    }

    @action reset = () => {
        this.searchStateObjs = this.initSearchStateObjs();
    };

    initBpm = () => {
        return {min: BPM_MIN, max: BPM_MAX};
    };

    @action updateSearchStr = (value, state) => {
        this.searchStr = value;
        const stateObj = this.searchStateObjs.find(obj => obj.state === state);
        if (stateObj) {
            stateObj.searchStr = value;
        }
    };

    @action updateSearchFilter = (filters, state) => {
        const stateObj = this.searchStateObjs.find(obj => obj.state === state);
        this.isFiltered = Object.keys(filters).some(key => (filters[key] && !filters[key].isAll));
        if (stateObj) {
            stateObj.filters = filters;
        }
    };


    @action loadSearchStrFrom = (state, id) => {
        const stateObj = this.searchStateObjs.find(obj => obj.state === state);
        if (stateObj && (stateObj.searchStr === null || id)) {
            this.searchStr = '';
            stateObj.searchStr = '';
            this.fetchItems(state, true, id);
        } else if (stateObj) {
            this.searchStr = stateObj.searchStr;
        }
    };

    @action fetchItems(state, isNew = false, searchId = null) {
        const stateObj = this.searchStateObjs.find(obj => obj.state === state);
        if (stateObj) {
            if (isNew) {
                stateObj.reset(0);
            }
            const str = stateObj.searchStr !== null ? stateObj.searchStr : '';
            if (stateObj.filters) {
                stateObj.fetch(str, stateObj.filters);
            } else if (stateObj.bpm) {
                stateObj.fetch(str, stateObj.bpm);
            } else {
                stateObj.fetch(str, searchId);
            }
        }
    }

    @action toggleFilterValue = (value, state, isAdd) => {
        const stateObj = this.searchStateObjs.find(obj => obj.state === state);
        if (stateObj) {
            if (isAdd) {
                this.searchStr = (`${this.searchStr} ${value}`).trim();
            } else {
                this.searchStr = this.searchStr.toLowerCase().replace(value.toLowerCase(), '').trim();
            }
            stateObj.searchStr = this.searchStr;
            this.fetchItems(state, true);
        }
    };

    @action updateBpmFilter = (values, state) => {
        const stateObj = this.searchStateObjs.find(obj => obj.state === state);
        const min = values[0];
        const max = values[1];
        if (stateObj) {
            stateObj.bpm.min = min;
            stateObj.bpm.max = max;
        }
    };

    @action resetSearchString = (state) => {
        const stateObj = this.searchStateObjs.find(obj => obj.state === state);
        if (stateObj) {
            stateObj.searchStr = null;
            this.searchStr = '';
            this.isFiltered = false;
        }
    };

    @action defaultReset() {
        return null;
    }

    getBpmValueFor = (state) => {
        const stateObj = this.searchStateObjs.find(obj => obj.state === state);
        if (stateObj && stateObj.bpm) {
            return stateObj.bpm;
        }
        return 0;
    };

    getSearchStrFor = (state) => {
        const stateObj = this.searchStateObjs.find(obj => obj.state === state);
        return (stateObj && stateObj.searchStr !== null ? stateObj.searchStr : '');
    }
}

const searchStore = new SearchStore();
export default searchStore;
